/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const pointsPerEuro = window.theme?.settings?.splioPoints || 1;

  document.addEventListener('theme:cart:change', () => {
    updateCartPoints();
  });

  document.addEventListener('theme:cart-drawer:open', () => {
    updateCartPoints();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCartPoints();
  });

  function updateCartPoints() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const subtotalCents = cart.total_price;
        const subtotalEuros = subtotalCents / 100;
        const points = Math.round(subtotalEuros * pointsPerEuro);
        const display = document.getElementById('cart-points-display');
        if (display) {
          if (points > 0) {
            display.textContent = '+ ' + points + ' point' + (points > 1 ? 's' : '') + ' avec notre programme de fidelite.';
            display.style.display = '';
          } else {
            display.style.display = 'none';
          }
        }
      });
  }


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
